import axios from 'axios';
import { API } from '../config';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';

const path = "/promotorias"

class PromotoriaService {
  getPromotorias() {
    return axios.get(API + path)
  }
  getPromotoriasLogado() {
    return axios.get(API + path + "/usuario-logado");
  }
  pesquisarPromotorias(filters) {
    const { nome, municipioId, municipios } = filters;

    return axios.get(API + path + "/pesquisar", {
      params: {
        nome: nome !== "" ? nome : undefined,
        municipioId: municipioId !== "" ? municipioId : undefined,
        municipios: municipios !== "" ? municipios : undefined
      },
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, v));
          } else if (value !== undefined && value !== null) {
            searchParams.append(key, value);
          }
        });
        return searchParams.toString();
      },
    });

  }
}
const instancePromotoria = new PromotoriaService();
export default instancePromotoria;